export default __webpack_public_path__ + "static/media/card-to-card-info-icon-4.f3758388.svg";